var map = {
	"./search-results.de-CH.json": 925,
	"./search-results.de-DE.json": 926,
	"./search-results.en-CA.json": 927,
	"./search-results.en-GB.json": 928,
	"./search-results.en-IN.json": 929,
	"./search-results.en-ME.json": 930,
	"./search-results.en-US.json": 931,
	"./search-results.es-EM.json": 932,
	"./search-results.es-ES.json": 933,
	"./search-results.fr-BE.json": 934,
	"./search-results.fr-CA.json": 935,
	"./search-results.fr-CH.json": 936,
	"./search-results.nl-BE.json": 937,
	"./search-results.nl-NL.json": 938,
	"./search-results.pl-PL.json": 939,
	"./search-results.pt-BR.json": 940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;